import { MdArrowDropDown } from 'react-icons/md';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const ProfilePhoto = styled.div`
  border-radius: 50%;
  position: relative;
  height: 36px;
  width: 36px;
  margin: 0 15px;
  background: #2d3d4a;
  color: ${(theme) => theme.COLOR_PRIMARY};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const ProfilePicture = styled.img`
  position: absolute;
  width: 100%;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
`;

const Initials = styled.span`
  font-size: 20px;
  text-decoration: none;
  text-transform: uppercase;
`;

const ProfileSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  min-width: 187px;
  padding: 5px;
  height: 60px;
  color: ${(theme) => theme.COLOR_PRIMARY};
  cursor: pointer;
  a {
    text-decoration: none;
  }
`;

const Span = styled.span`
  font-size: 12px;
`;

const Icons = styled.div`
  font-size: 24px;
  height: 24px;
  svg {
    cursor: pointer;
    transition: color 0.1s ease-in-out;
    @media (hover: hover) {
      &:hover {
        color: ${(theme) => theme.COLOR_SECONDARY};
      }
    }
  }
`;

const Main = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: 30px;
  margin-right: 30px;
  user-select: none;
`;

const DropDown = styled.div`
  position: absolute;
  display: flex;
  top: 55px;
  right: 3px;
  border-radius: 4px;

  .card {
    justify-content: flex-start;
    padding: 0;
  }

  .card-item {
    height: 30px;
    text-align: left;
    background-color: white;
    border: none;
    font-size: 14px;
    white-space: nowrap;
    width: 100%;
    display: block;

    @media (hover: hover) {
      &:hover {
        background: rgba(51%, 81%, 94%, 25%);
        color: #77c3ec;
        font-weight: normal;
        cursor: pointer;
      }
    }
  }
`;

const DropdownIcon = styled(MdArrowDropDown)`
  color: ${({ theme }) => theme.COLOR_GREY3};
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  border-radius: 50%;
  margin-left: 6px;
  color: ${({ theme, $active }) => ($active ? theme.COLOR_TEXT : 'none')};
`;

const OptionNavlink = styled(NavLink)`
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${({ theme }) => theme.COLOR_GREY_TEXT};
  padding: 0 4px;

  svg {
    margin: 0 14px;
  }

  span {
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.20000000298023224px;
    text-align: left;
  }

  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.COLOR_GREY5};
      span {
        font-weight: 600;
        color: ${({ theme }) => theme.COLOR_BLACK};
      }

      svg {
        color: ${({ theme }) => theme.COLOR_BLACK};
      }
    }
  }
`;

const DropDownHeading = styled.div`
  height: 40px;
  span {
    text-transform: uppercase;
  }
  padding: 0 16px;
`;

const ProfileComponentStyle = {
  ProfilePhoto,
  ProfilePicture,
  Initials,
  ProfileSection,
  Span,
  Icons,
  DropDownHeading,
  Main,
  DropDown,
  DropdownIcon,
  Option,
  OptionNavlink,
};

export default ProfileComponentStyle;
